import _styled from "@emotion/styled-base";
import { Box, Flex, Text, Button } from '@risk-first/ui-core';
import { themeGet } from '@styled-system/theme-get';
import { withTheme } from 'emotion-theming';
import React from 'react';

const Paragraph = /*#__PURE__*/_styled(Box, {
  target: "elyggwm0",
  label: "Paragraph"
})({
  name: "19l57or",
  styles: "letter-spacing:0.05em;line-height:1.25;max-width:360px;"
});

const Header = withTheme(props => {
  const {
    name,
    logo
  } = props;
  return React.createElement(Flex, {
    alignItems: "center",
    flexDirection: "column"
  }, React.createElement(Box, null, logo), React.createElement(Paragraph, {
    marginY: `${themeGet('space.4')(props)}px`
  }, React.createElement(Text, {
    textAlign: "center",
    fontSize: "1rem",
    fontFamily: themeGet('fontFamily')(props),
    color: themeGet('colors.darkGrayishBlue')(props)
  }, "Welcome to ", name, ", please use the button below to login and start using the application.")));
});
const LOGIN_BUTTON_TEXT = 'Login';
const Login = withTheme(props => {
  const {
    applicationName,
    applicationLogo,
    onLoginClick
  } = props;
  return React.createElement(Flex, {
    bg: "white",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    pt: `${themeGet('space.5')(props)}px`
  }, React.createElement(Box, {
    maxWidth: '400px'
  }, React.createElement(Header, {
    name: applicationName,
    logo: applicationLogo
  })), React.createElement(Box, {
    maxWidth: '360px'
  }, React.createElement(Button, {
    variant: "default",
    size: "regular",
    width: "160px",
    onClick: onLoginClick
  }, LOGIN_BUTTON_TEXT)));
});
export { Login };
//# sourceMappingURL=index.js.map
